module.exports = __webpack_public_path__ + "static/media/visa.7e005efb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment-methods/visa.png
// module id = 577
// module chunks = 0